export default "__VITE_ASSET__d6zb9wN6__"